<template>
<div>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateMain"
        :label="itemAction.name"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        dense
        outlined
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dateMain"
      min="1950-01-01"
      @change="save"
      locale="es"
    ></v-date-picker>
  </v-menu>
</div>
</template>

<script>
export default {
  props: {
    setterModel: String,
    itemAction: Object,
    onSuccess: Function// eslint-disable-line
  },
  data: (vm) => ({
    // date: new Date().toISOString().substr(0, 10),
    dateMain: '',
    menu: false
  }),
  mounted () {
    this.Stringdate(this.setterModel)
    // this.save(this.date)
  },
  watch: {
    setterModel (date) {
      try {
        if (date) {
          this.dateMain = date.substr(0, 10)
        }
      } catch (error) {
        this.dateMain = ''
      }
    }
  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      if (date != null) {
        this.onSuccess({ id: this.itemAction.nameid, data: date })
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    Stringdate (date) {
      try {
        if (date) {
          this.dateMain = date.substr(0, 10)
        }
      } catch (error) {
        this.dateMain = ''
      }
    }
  }
}
</script>

<style>

</style>
